<template>
    <div ref="content" style="background-color: #eceef7da !important; padding: 2%" >
        <h5 class="mb-2">
            {{nameStudent}}
        </h5>
        <div style="background-color:white;justify-content: space-between; margin-top: 11px; border-radius: 3px; padding: 10px"  vs-justify="center" vs-align="center" w="12"> 
            <!-- FILTROS PADRES -->
            <vs-row style="margin-top: 1.3em">
                <vs-col class="pl-1 pr-1 mb-1" vs-type="flex" vs-justify="center" vs-align="right"  offset="0" xs="12" lg="5">
                    <form autocomplete="off">
                        <vs-select :loading="loadingInstitucion" filter label-placeholder="Institución" :key="institucionId" v-model="institucion"  @input="onChangeInstitucion" :disabled="!listInstituciones.length" @click="obtenerValor += 1">
                            <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col class="pl-1 pr-1 mb-1" vs-type="flex" vs-justify="center" vs-align="right"  offset="0" xs="12" lg="5">
                    <form autocomplete="off">
                        <vs-select :loading="loadingCiclo" class="mr-0" filter label-placeholder="Ciclo Escolar" v-model="cicloEscolar"  :key="cicloId" :disabled="!listCiclos.length">
                            <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col> 
            </vs-row>
            <!-- END FILTROS PADRES  -->

            <!-- BOTONES PARA DESCARGAR ESTADO DE CUENTA  -->
            <div class="d-flex justify-content-end">
                <vs-button
                    flat
                    @click="getEstadoCuenta('especifico')"
                >
                    Estado de cuenta ciclo escolar actual
                </vs-button>
                <vs-button
                    v-if="listCiclos[1]"
                    success
                    flat
                    @click="getEstadoCuenta('general')"
                >
                    Estado de cuenta historico
                </vs-button>
            </div>
            <!-- END BOTONES PARA DESCARGAR ESTADO DE CUENTA  -->

            <!-- OPCIONES DE VISUALIZACIÓN  -->
            <vs-row class="my-4">
                <vs-col sm="12" lg="4">
                    <div :class="showOptionMenu == 'cargos' ? 'optionsTabSelect' : 'optionsTab'" @click="showMenu('cargos')">
                        <h6 class="mb-0">Cargos</h6>
                    </div>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <div :class="showOptionMenu == 'pagos' ? 'optionsTabSelect' : 'optionsTab'" @click="showMenu('pagos')">
                        <h6>Pagos y promociones</h6>
                    </div>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <div :class="showOptionMenu == 'servicios' ? 'optionsTabSelect' : 'optionsTab'" @click="showMenu('servicios')">
                        <h6>Servicios no obligatorios</h6>
                    </div>
                </vs-col>
            </vs-row>
            <!-- END OPCIONES DE VISUALIZACIÓN  -->

            <!-- CONTENIDO DE VISUALIZACIÓN  -->
            <div>
                <h4 class="card-content mb-4 text-left">{{titulo[showOptionMenu]}} {{cicloEscolarName}}</h4>
            </div>
            <div v-show="showOptionMenu == 'cargos'">
                <v-cargo ref="estadisticaCargos" :persona-id="personaId" :institucion="institucion" :ciclo-escolar="cicloEscolar"></v-cargo>
                <cargos ref="tablaCargos" :permisos="permisos" :persona-id="personaId" :institucion="institucion" :ciclo-escolar="cicloEscolar" :listNivel="listNivel"  :nivel="nivel" :nivelId="nivelId" :listPrograma="listPrograma" :programa="programa" :programaId="programaId" :cuentaGuardada="cuentaGuardada" :general="general"  @refreshTable="getBalance" :programaDefault="programaDefault" :personaRol="personaRol"></cargos>
            </div>
            <div v-show="showOptionMenu == 'pagos'">
                <v-estadistica ref="estadisticaPagos" :persona-id="personaId" :institucion="institucion" :ciclo-escolar="cicloEscolar"></v-estadistica>
                <pagos ref="tablaPagos" :permisos="permisos" :persona-id="personaId" :institucion="institucion" :ciclo-escolar="cicloEscolar" @loading="openLoading" @endLoading="closeLoading"  @refreshTable="getBalance" :permisosFamiliar="permisosFamiliar" :personaRol="personaRol"></pagos>
            </div>
            <div v-show="showOptionMenu == 'servicios'">
                <noObligatorios ref="tablaNoObligatorio" :permisos="permisos" :persona-id="personaId" :institucion="institucion" :ciclo-escolar="cicloEscolar" :listNivel="listNivel"  :nivel="nivel" :nivelId="nivelId" :listPrograma="listPrograma" :programa="programa" :programaId="programaId" :cuentaGuardada="cuentaGuardada" @refreshTable="getBalance" :programaDefault="programaDefault" :personaRol="personaRol" :general="general" ></noObligatorios>
            </div>
            <!-- END CONTENIDO DE VISUALIZACIÓN  -->
        </div>
    </div>
</template>

<script>
import cardGeneral from './cards-estadisticos.vue'
import pagos from './tabla-pagos.vue'
import estadisticas from './estadisticas-pago.vue'
import cargos from './tabla-cargos.vue'
import cobranza from '../../../../api/requests/cobranza-persona.js'
import catalogos from '../../../../api/requests/catalogos.js'
import noObligatorios from './tabla-no-obligatorios.vue'
import profesor from '../../../../api/requests/landing-profesor'
import alumnos from '../../../../api/requests/alumno'

export default {
    props:[
        'personaRol',
        'alumnoClicked',
        'nameStudent',
        'idPersona'
    ],
    data () {
        return {
            obtenerValor: 0,
            showOptionMenu:'cargos',
            general: [],
            personaId: '',
            titulo: {
                "cargos": "Cargos del",
                "pagos": "Detalle de pagos y promociones del",
                "servicios": "Servicios no obligatorios del "
            },
            institucion: '',
            cicloEscolar: '',
            listInstituciones:[],
            listCiclos: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            institucionId: (new Date()).getTime(),
            loadingInstitucion: false,
            loading: null,
            permisos: [],
            
            programaId: (new Date()).getTime(),
            nivelId: (new Date()).getTime(),
            programa: '',
            nivel: '',
            listPrograma: [],
            listNivel: [],
            errorFields: [],
            nivelDefault: null,
            programaDefault: null,
            nivelInfo:[],
            infoForm: [],
            permisosFamiliar: [],
            cuentaGuardada: [],
            permisosInfo: [],
        }
    },
    components:{
        cardGeneral,
        pagos,
        cargos,
        estadisticas,
        noObligatorios
    },
    async created(){  
        let urlParams = new URLSearchParams(window.location.search);
        this.personaId = parseInt(urlParams.get("persona_id"));
        this.institucion = parseInt(urlParams.get("institucion_id"));
        this.cicloEscolar = parseInt(urlParams.get("ciclo_escolar_id"));
    },
    computed: {
        cicloEscolarName () {
            if (parseInt(this.cicloEscolar)) {
                const selectedItem = this.listCiclos.find( e => e.id === parseInt(this.cicloEscolar) )
                if (selectedItem){
                    return `del ${selectedItem.text}`
                }
            }
            return ''
        }
    },
    methods: {
        async getInfoGeneral(){
            const params = {
                institucion_id: this.institucion,
                ciclo_escolar_id: this.cicloEscolar
            }
            const { data: response} = await alumnos.getInfoGeneral(this.personaId, params)
            this.general = {
                "datos": response,
                "permisos": response.visibilidad,
                "idAlumno": response.persona_id
            }
        },
        showMenu(tipo){
            if(tipo == 'cargos'){
                this.showOptionMenu = 'cargos'
            }else if(tipo == 'pagos'){
                this.showOptionMenu = 'pagos'
            }else if(tipo == 'servicios'){
                this.showOptionMenu = 'servicios'
            }
        },
        async getEstadoCuenta(tipo){
            // DESCARGA LOS ESTADOS DE CUENTA EN PDF 
            try{
                if(tipo == 'especifico'){
                    const url = '/estado-cuenta/reporteGeneral?institucion=' + this.institucion + '&ciclo_escolar=' + this.cicloEscolar + '&programa=' + this.programa + '&nivel_academico=' + this.nivel + '&persona_id=' + this.personaId
                    window.open(url)
                }else {
                    const ciclos = []
                    this.listCiclos.forEach(element => {
                        ciclos.push('&ciclo_escolar[]=' + element.id)
                    })
                    const url = '/estado-cuenta/reporteGeneral?institucion=' + this.institucion + ciclos.join('') + '&programa=' + this.programa + '&nivel_academico=' + this.nivel + '&persona_id=' + this.personaId + '&type=general'
                    window.open(url)
                }
            }catch(error){
                console.log(error)
            }
        },
        openLoading (){
            this.loading = this.$vs.loading({
            target: this.$refs.content
          })
        },
        closeLoading() {
            this.loading.close()
        },
        async getPermisos () {
            try {
                const params = {
                    "seccion" : 'finanzas-alumnos'
                }
                const { data: perm } = await catalogos.getPermisosSeccion(params)
                if (perm instanceof Object){
                    this.permisos = perm.permisos

                }
            } catch (error) {
                console.log(error)
            }            
        },
        
        async getBalance(){
            if(this.nivel){
                this.balance = []
                this.$emit('loadingState', true)
                try {
                    const params = {
                        institucion: this.institucion,
                        ciclo_escolar: this.cicloEscolar,
                        programa: this.programa,
                        nivel_academico: this.nivel,
                        id: this.personaId
                    }
                    const { data: response } = await profesor.getBalance(params)
                    if(response){
                        this.getPagosCargos()
                    }
                    // loading.close()
                    this.$emit("ejecutarLoading", false)
                } catch (error) {
                    // loading.close()
                    this.$emit("ejecutarLoading", false)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Hubo un error',
                        text: 'No se obtuvo información, favor de ponerse en contacto con el administrador.'
                    })
                }
            }
        },
        async getPagosCargos(){
            if(this.institucion && this.cicloEscolar && this.personaId){
                await new Promise(r => setTimeout(r, 100))
                try {
                    // const loading = this.$vs.loading({
                    //     target: this.$refs.content
                    // })
                    await this.$refs.tablaPagos.getPagos();
                    await this.$refs.tablaCargos.getCargos();
                    await this.$refs.tablaNoObligatorio.getNoObligatorios();
                    await this.$refs.estadisticaPagos.getEstadisticasPagos();
                    await this.$refs.estadisticaCargos.getEstadisticasCargos();
                    // loading.close()
                    this.$emit('loadingState', false)
                } catch (error) {
                    loading.close()
                    console.log(error)
                }
            }
        },
        async getCargosAndPagos(){
            await this.$refs.estadisticaCargos.getEstadisticasCargos();
        },
        onChangeInstitucion () {
            this.listCiclos = []
            this.listarCiclos()
        },
        async listarCiclos () {
            if (this.institucion){
                try {
                    this.getCicloDefault()
                } catch (error) {
                        
                }
            }else {
                this.listCiclos = []
            }
        },
        async getInstitucioneDefault () {
            this.loadingInstitucion = true
             let params = {
                "persona": this.personaId
            }
            const { data: response } = await catalogos.getInstitutosDefault(params) || {}
            const { opciones: info, default: val } = response || {}
            this.listInstituciones = info instanceof Object ?  Object.values(info) : []
            this.institucionId = (new Date()).getTime()
            this.loadingInstitucion = false
            this.listarCiclos()
        },
        async getCicloDefault() {
            this.loadingCiclo = true
            let params = {
                "nivel_academico": this.nivel,
                "institucion_id": this.institucion,
                "persona_id": this.personaId
            }
            const { data: response } = await catalogos.getCicloDefault(params) || {}
            const { opciones: info, default: val = null } = response || {}
            this.listCiclos = info instanceof Object ?  Object.values(info) : []
            if(this.obtenerValor != 0){
                this.cicloEscolar = response.default
            }
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },

        onChangeNiveles () {
            this.listPrograma = []
            this.programa = ''
            this.getProgramas()
            this.openLoading()
        },
        async getNivelesAcademicos () {
            if (this.programa){
                let params = {
                programa: this.programa,
                institucion: this.institucion,
                }
                const { data: response } = await cobranza.getNivel(params) || {}
                const { opciones: niveles, default: val } = response || {}
                if (niveles){
                    this.nivel = val
                }
                this.getBalance()
            }
        },
        async getProgramas () {
            if (this.institucion && this.cicloEscolar){
            let params = {
                institucion_id: this.institucion,
                persona_id: this.personaId,
                ciclo_escolar_id: this.cicloEscolar,
            }

            if (this.nivel){
                params.nivel_academico = this.nivel
            }
            
            
            const { data: response } = await cobranza.getPrograma(params) || {}
            const { opciones: programas, default:val } = response || {}
                if (programas){
                    this.listPrograma = Object.values(programas)
                    this.programa = val
                    this.programaDefault = val
                    this.programaId = (new Date()).getTime()
                }
            }
        },
        async initCatalogs() {
            if (!this.listNivel.length){
            try {
                await this.getNivelesAcademicos()
            } catch (error) {
                console.log(error)
            }
            }
            if (!this.listPrograma.length){
            try {
                await this.getProgramas()
            } catch (error) {
                console.log(error)
            }
            }
        },
    },
    watch: {
        async cicloEscolar() {
            this.programa = ''
            this.nivel = ''
            this.getInfoGeneral()
            await this.getProgramas()
            await this.getNivelesAcademicos()
        },
        institucion(){
            this.getInstitucioneDefault()
        },
        personaId(){
            this.getPermisos()  
        },
        alumnoClicked(){
            this.obtenerValor = 0
            if(this.institucion == this.alumnoClicked.institucion_id){
                this.getInstitucioneDefault()
                this.listarCiclos()
            }
            if(this.cicloEscolar == this.alumnoClicked.ciclo_escolar_id){
                this.getProgramas()
                this.getNivelesAcademicos()
            }
            this.institucion = this.alumnoClicked.institucion_id
            this.cicloEscolar = this.alumnoClicked.ciclo_escolar_id
            this.personaId = this.idPersona
        }
    }
}

</script>

<style scoped>
.md-stepper{
    padding: 16px 0 !important;
}
.md-steppers-navigation{
    box-shadow: -1px 4px 6px -3px rgba(0,0,0,0.87) !important;
    -webkit-box-shadow: -1px 4px 6px -3px rgba(0,0,0,0.87) !important;
    -moz-box-shadow: -1px 4px 6px -3px rgba(0,0,0,0.87) !important;
}
</style>

<style lang="scss"  scoped >


.optionsTabSelect{
    color: #2874A6;
    border-bottom: 1px solid #2874A6;
    padding: 0.3rem;
    text-align: center;
    cursor:pointer;
    h6{
        margin-bottom: 0;
    }
}
.optionsTab{
    color: #CACFD2;
    background: #F2F3F4;
    padding: 0.3rem;
    text-align: center;
    cursor:pointer;
    h6{
        margin-bottom: 0;
    }
    &:hover {
        color: #adafb1;
        background: #ebebeb;
    }
}
.separated {
    margin: 0.7em  !important;   
}
.md-list {
     padding: 0.7rem;
}

.md-divider {
    height: 1px;
    color: #4b647a98 !important;
}

.md-card .md-card-header .vs-avatar-content{
    height: 100% !important; 
}

.md-card-header-text {
    margin-left: 1em;
}

.md-progress-bar {
    margin: 24px;
}

.table-search-button {
    margin: 0px auto 0px auto;
    @media only screen and (max-width: 768px) {
        margin: 0 0 0 auto;
  }
}

.vs-select-content {
    padding: 0 !important;
    width: 100%;
    max-width: 100%;
    @media only screen and (max-width: 768px) {
        margin-bottom: 5%;
  }
}

.card-content{
    @media only screen and (max-width: 768px) {
        text-align: center;
    }
}
.fontMedium{
    font-size: 13px;
}

.hoverList :hover{
    background: rgba(165,165,165,0.1);
    cursor: pointer;
}

.md-succes{
    background: #28a745;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 22%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-info{
    background: #9e16aa;
    color: white;
    border-radius: 7px;
}

.md-dark{
    background: #19191a;
    color: white;
    border-radius: 7px;
}

/* Style the list */
ul.breadcrumb {
  padding: 10px 16px;
  list-style: none;
  background-color: #eee;
}

/* Display list items side by side */
ul.breadcrumb li {
  display: inline;
  font-size: 18px;
}

/* Add a slash symbol (/) before/behind each list item */
ul.breadcrumb li+li:before {
  padding: 8px;
  color: black;
  content: "/\00a0";
}

/* Add a color to all links inside the list */
ul.breadcrumb li a {
  color: #0275d8;
  text-decoration: none;
}

/* Add a color on mouse-over */
ul.breadcrumb li a:hover {
  color: #01447e;
  text-decoration: underline;
}
</style>
